<template>
  <PerfectScrollbar>
    <div style="min-height: 9000px;">
      <slot />
    </div>
  </PerfectScrollbar>
</template>

<script>
export default {
  name: 'BlankLayout',
}
</script>

<style>
.ps {
  height: 100%;
}
</style>
